// The columns of a suggested table field: tick or untick each, change its
// type, and see the first rows the AI read from the sample document.

const COLUMN_TYPES = ["text", "number", "currency", "date"];

export default function TableSuggestionDetail({ item, onChangeColumn }) {
  const columns = item?.columns || [];
  const rows = (item?.sample_rows || []).slice(0, 3);
  if (!columns.length) return null;

  return (
    <div className="space-y-2" onClick={(e) => e.stopPropagation()}>
      <ul className="divide-y divide-gray-100 dark:divide-gray-800 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
        {columns.map((c) => {
          const on = c.selected !== false;
          return (
            <li key={c.key} className="flex items-start gap-2 px-2.5 py-1.5">
              <input
                type="checkbox"
                className="mt-0.5 accent-purple-600"
                checked={on}
                onChange={() => onChangeColumn(c.key, { selected: !on })}
                aria-label={`Include column ${c.label}`}
              />
              <div className={`flex-1 min-w-0 ${on ? "" : "opacity-50"}`}>
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-gray-900 dark:text-gray-100">{c.label}</span>
                  <span className="text-[10px] font-mono text-gray-400">{c.key}</span>
                  {c.requested && (
                    <span className="text-[10px] px-1.5 rounded bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300">
                      requested
                    </span>
                  )}
                </div>
                {c.description && (
                  <p className="text-[11px] text-gray-500 dark:text-gray-400 line-clamp-2" title={c.description}>
                    {c.description}
                  </p>
                )}
              </div>
              <select
                value={COLUMN_TYPES.includes(c.type) ? c.type : "text"}
                onChange={(e) => onChangeColumn(c.key, { type: e.target.value })}
                disabled={!on}
                className="text-[11px] rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-1 py-0.5"
                aria-label={`Type of column ${c.label}`}
              >
                {COLUMN_TYPES.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </li>
          );
        })}
      </ul>

      {rows.length > 0 && (
        <div className="overflow-x-auto">
          <p className="text-[10px] uppercase tracking-wide text-gray-400 mb-1">
            Rows read from the sample{item.row_count > rows.length ? ` (first ${rows.length} of ${item.row_count})` : ""}
          </p>
          <table className="min-w-full text-[11px] border border-gray-200 dark:border-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-800/60">
              <tr>
                {columns
                  .filter((c) => c.selected !== false)
                  .map((c) => (
                    <th key={c.key} className="px-2 py-1 text-left font-medium text-gray-600 dark:text-gray-300 whitespace-nowrap">
                      {c.label}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-t border-gray-100 dark:border-gray-800">
                  {columns
                    .filter((c) => c.selected !== false)
                    .map((c) => (
                      <td key={c.key} className="px-2 py-1 text-gray-700 dark:text-gray-300 max-w-[14rem] truncate" title={r[c.key] || ""}>
                        {r[c.key] || ""}
                      </td>
                    ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
